import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AptorApi, useAptorApi, useFetchSelectOptions } from '../../../../Api';
import { Loading } from '../../../../Components';
import { FormValues } from '../../../../Components/Form/Form.types';
import { CreateCustomerForm } from './CreateCustomer.Form';

export const CreateCustomer = () => {
  const navigate = useNavigate();
  const { api, abortController } = useAptorApi();

  const [languages] = useFetchSelectOptions(
    useCallback(() => api.getLanguages(), [api]),
    abortController,
  );

  const [features] = useFetchSelectOptions(
    useCallback(() => api.newCustomer(), [api]),
    abortController,
  );

  const [countries] = useFetchSelectOptions(
    useCallback(() => api.getCountries(), [api]),
    abortController,
  );
  const [onboardingUsers, , onboardingUsersLoaded] = useFetchSelectOptions(
    useCallback(() => api.getOnboardingUsers(), [api]),
    abortController,
  );
  const formatLocalDateTime = (date: Date): string => {
    const pad = (num: number) => String(num).padStart(2, '0');
    
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    
     return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };
  const handleSubmit = async (data: FormValues, api: AptorApi, onSuccess: (key: string) => void) => {
     await api.createCustomer(data.inactivationDate ? {...data, inactivationDate: formatLocalDateTime(data.inactivationDate as Date)} : data);
     onSuccess('admin.customers.new.savedCustomer');
     navigate('/admin/customers');
  };

  if (!onboardingUsersLoaded || features.length === 0 || languages.length === 0 || countries.length === 0) {
    return <Loading />;
  }

  return <CreateCustomerForm features={features} countries={countries} languages={languages} onboardingUsers={onboardingUsers} submit={handleSubmit} />;
};
